import classNames from 'clsx'
import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from 'prop-types'

const NativeSelect = props => {
  const {
    label,
    options,
    showLabel,
    forceDefaultSelection,
    defaultValue,
    floatingLabel,
    allowLinks,
    smaller,
    selectedValue,
    dataQa,
    ...rest
  } = props

  return (
    <select
      {...rest}
      className={classNames('m-Select', {
        'm-Select--label': showLabel,
      })}
      defaultValue={defaultValue}
      data-label={label}
      data-clientside-hook="select"
      data-qa-id={dataQa}
    >
      {!defaultValue && !forceDefaultSelection ? (
        <option selected>{label}</option>
      ) : null}
      {options.map(({ value, disabled, text }) => (
        <option key={value} value={value} disabled={Boolean(disabled)}>
          {text}
        </option>
      ))}
    </select>
  )
}

NativeSelect.propTypes = {
  id: string.isRequired,
  name: string.isRequired,
  label: string.isRequired,
  selectedValue: oneOfType([string, number]),
  options: arrayOf(
    shape({
      value: oneOfType([string, number]).isRequired,
      text: string.isRequired,
      disabled: bool,
    })
  ).isRequired,
  showLabel: bool,
  floatingLabel: bool,
  smaller: bool,
  onChange: func,
  className: string,
  allowLinks: bool,
  forceDefaultSelection: bool,
  dataQa: string,
  defaultValue: oneOfType([number, string]),
}

NativeSelect.defaultProps = {
  defaultValue: null,
  selectedValue: null,
  showLabel: true,
  floatingLabel: null,
  smaller: false,
  onChange: null,
  className: '',
  allowLinks: false,
  dataQa: undefined,
  forceDefaultSelection: true,
}

export default NativeSelect
